import React, { useRef } from "react";
import { useState, useEffect } from "react";
import "../App.css";
import "./cardImg.css";
import "./countdown.css";
import "./borderAni.css";
import { FaAddressCard } from "react-icons/fa";
import { LuWallet } from "react-icons/lu";
import { BsBank } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import {
  buyPackageApi,
  claimFreeToken,
  getUserDataApi,
  updateSalaryIndexApi,
} from "../utils/apiHandlers";
import { setUserInfo } from "../Redux/WallatSlice";
import {
  useReadContractMethods,
  useWriteContractMethods,
} from "../utils/contractHelper";
import { verifyTransaction } from "../utils/Web3";
import toast from "react-hot-toast";
import { useAccount } from "wagmi";
import ConnectWallet from "../components/ConnectWallet";
import { GiStoneBlock } from "react-icons/gi";
import { origin_url } from "../utils/Config";
import { getDaysOld } from "../utils/helperFunctions";

const DashboardHome = () => {
  const { walletAddress, userinfo, jwt } = useSelector((state) => state.wallet);
  const { isConnected, address } = useAccount();
  const [selectedPkg, setSelectedPkg] = useState(0);
  const [copied, setCopied] = useState(false);
  const [timer7day, setTimer7Day] = useState("");
  const dispatch = useDispatch();
  const { transferUSDT, approve } = useWriteContractMethods;
  const { getAllowance } = useReadContractMethods;
  const timerRef = useRef();

  const handleCopy = (val) => {
    const inputval = val || document.getElementById("referralLink").value;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(inputval).then(() => {
        // setCopied(true);
        // setTimeout(() => setCopied(false), 2000); // Reset copied message after 2 seconds
        toast.success("copied successfuly!");
      });
    } else {
      alert("Clipboard API is not supported on your browser.");
    }
  };

  async function handleStake() {
    try {
      const allowance = await getAllowance(walletAddress);
      const stkamt = userinfo?.packages[selectedPkg];
      console.log(
        Number(allowance) / 1e18,
        stkamt,
        Number(allowance) <= stkamt * 1e18,
        " allowance, stakeamt"
      );
      if (Number(allowance) <= stkamt * 1e18) {
        const approvetxhash = await approve(Number(stkamt));
        const approveresp = verifyTransaction(approvetxhash);
        await toast.promise(approveresp, {
          loading: "approval in progress...",
          success: () => {
            toast.success("USDT approve success!");
          },
          error: "Sorry approval failed",
        });
      }
      const txhash = await transferUSDT(Number(stkamt) * 1e18);
      const resp = verifyTransaction(txhash);
      const txresp = await toast.promise(resp, {
        loading: "stake USDT in progress...",
        success: () => {
          // refreshData();
          // toast.success("stake USDT success!");
        },
        error: "Sorry stake USDT failed",
      });
      console.log("transferres", txresp);
      if (txresp?.status == "success") {
        const stkres = buyPackageApi(
          { plan: selectedPkg + 1, user: walletAddress },
          jwt
        );
        const fres = await toast.promise(stkres, {
          loading: "stake USDT in progress...",
          success: () => {
            refreshData();
            toast.success("stake USDT success!");
          },
          error: "Sorry stake USDT failed",
        });
        console.log(fres, " stake response");
      }
    } catch (e) {
      console.log(e, "stake errro");
    }
  }

  async function handleClaim() {
    try {
      const stkres = claimFreeToken(jwt);
      const fres = await toast.promise(stkres, {
        loading: "claim BlockAI Token in progress...",
        success: () => {
          refreshData();
          toast.success("claim BlockAI success!");
        },
        error: "Sorry claim BlockAI failed",
      });
      console.log(fres, " fres");
    } catch (e) {
      console.log(e, "stake errro");
    }
  }

  async function refreshData() {
    const sres = await updateSalaryIndexApi(jwt);
    console.log(sres, " salary update res");
    getUserDataApi(jwt, { email: userinfo?.email, address: walletAddress })
      .then(async (res) => {
        if (res?.status == 200) {
          dispatch(setUserInfo(res?.data));
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  async function refreshStake() {
    try {
      const stkres = buyPackageApi({ user: walletAddress }, jwt);
      const fres = await toast.promise(stkres, {
        loading: "updating stake...",
        success: () => {
          refreshData();
          toast.success("stake USDT success!");
        },
        error: "Something went wrong",
      });
    } catch (e) {
      console.log(e, " error in refresh stake");
    }
  }

  useEffect(() => {
    if (jwt && userinfo?.email) {
      refreshData();
    }
    if (jwt) {
      updateSalaryIndexApi(jwt);
    }
  }, [walletAddress, jwt]);

  useEffect(() => {
    if (userinfo?.timestamp) {
      getDaysOld(userinfo?.timestamp, 30, setTimer7Day, timerRef);
    }
    return () => {
      clearInterval(timerRef.current);
    };
  }, [userinfo]);

  return (
    <>
      <div className="bodybg">
        <div className="container-fluid">
          <div className="row mb-3">
            {copied && (
              <span style={{ marginLeft: "10px", color: "green" }}>
                Copied!
              </span>
            )}
          </div>
          {/* profile section commented */}
          {/* <div className="row mb-3">
            <div class="col-xl-8">
              <div class="card text-white mb-2 box borderAni">
                <div class="card-body" style={{ height: "290px" }}>
                  <div class="text-center">
                    <img
                      src="assets copy/9187604.png"
                      alt="Profile Photo"
                      class="img-fluid rounded-circle mb-2"
                      style={{ width: "100px", height: "100px" }}
                    />
                  </div>
                  <h5 class="card-title text-white">
                    User-ID : {userinfo?.user_id}
                  </h5>

                  <h6 className=" mt-10">
                    <span>Wallet Address:</span>{" "}
                    <span class="text-white">
                      {walletAddress?.slice(0, 6)}...
                      {walletAddress?.slice(-6)}
                      <span
                        onClick={() => handleCopy(walletAddress)}
                        className=" mx-2"
                      >
                        <i
                          class="fa fa-copy"
                          style={{ fontSize: "15px", color: "#5D87FF" }}
                        ></i>
                      </span>
                    </span>
                  </h6>
                  <h6 className=" mt-10">
                    <span>Referrer Wallet:</span>{" "}
                    <span class="text-white">
                      {userinfo?.referrer?.slice(0, 6)}...
                      {userinfo?.referrer?.slice(-6)}
                      <span
                        onClick={() => handleCopy(userinfo?.referrer)}
                        className=" mx-2"
                      >
                        <i
                          class="fa fa-copy"
                          style={{ fontSize: "15px", color: "#5D87FF" }}
                        ></i>
                      </span>
                    </span>
                  </h6>
                  <h6 className=" mt-10">
                    <span>Join Date: </span>{" "}
                    {new Date(userinfo?.timestamp * 1000).toLocaleString()}
                  </h6>
                  <h6 className=" mt-10">
                    <span>
                      Referal Link:{" "}
                      {`${origin_url}/?referral=${
                        "..." + userinfo?.user.slice(-9)
                      }`}
                      <span
                        onClick={() =>
                          handleCopy(
                            `${origin_url}/?referral=${userinfo?.user}`
                          )
                        }
                        className=" mx-2"
                      >
                        <i
                          class="fa fa-copy"
                          style={{ fontSize: "15px", color: "#5D87FF" }}
                        ></i>
                      </span>
                    </span>{" "}
                    {}
                  </h6>
                </div>
                <span
                  style={{ alignSelf: "flex-end", margin: "10px" }}
                  className="btn"
                  // onClick={() => refreshStake()}
                >
                  {userinfo?.totalEarned >= userinfo?.totalLimit &&
                    userinfo?.totalLimit > 0 && (
                      <span className=" text-danger mx-3">
                        Please Upgrade Your Plan, Limit Reached
                      </span>
                    )}
                  Refresh stake
                </span>
              </div>
            </div>
          </div> */}
          <div className="row m-2 blockarea borderAni">
            <div>
              <div className="col-xl-12 d-lg-flex justify-content-between p-4">
                <div className="col-xl-3 mb-2">
                  <div
                    className="h-200"
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      backgroundColor: "#041025",
                      padding: "5px",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center walletImg">
                      <div className="mx-2 my-2">
                        <h6 className="fw-bolder">Free Block</h6>
                        <h6 className="fw-bolder">
                          ${Number(userinfo?.airdropWallet)?.toFixed(2)}
                        </h6>
                      </div>
                      <div
                        className="p-2 mx-2"
                        style={{
                          backgroundColor: "#001a49",
                          borderRadius: "10%",
                          color: "white",
                        }}
                      >
                        <GiStoneBlock
                          style={{
                            fontSize: "20px",
                          }}
                        />
                      </div>
                    </div>
                    <div className="stake-left d-flex justify-content-between align-items-center">
                      <div className="d-flex py-2">
                        <div
                          className="p-2 m-2"
                          style={{
                            backgroundColor: "#092b4a",
                            borderRadius: "10%",
                            color: "white",
                          }}
                        >
                          {/* <LuWallet
                            style={{
                              fontSize: "30px",
                            }}
                          /> */}
                          <img
                            src={require("../assets/block-flash.png")}
                            style={{
                              height: "35px",
                              backgroundSize: "cover",
                              borderRadius: "5px",
                            }}
                          />
                        </div>
                      </div>
                      <div>
                        <h6 className="fw-bolder">Total Rewards</h6>
                        <h6 className="fw-bolder">
                          $ {Number(userinfo?.autoStake?.roi || 0)?.toFixed(2)}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 mb-2">
                  <div
                    className="h-200"
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      backgroundColor: "#041025",
                      padding: "5px",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center walletImg">
                      <div className="mx-2 my-2">
                        <h6 className="fw-bolder">Team Block Amt.</h6>
                        <h6 className="fw-bolder">
                          $(
                          {Number(userinfo?.directTeamBusiness) ||
                            0 + (Number(userinfo?.totalTeamBusiness) || 0)}
                          )
                        </h6>
                      </div>
                      <div
                        className="p-2 mx-2"
                        style={{
                          backgroundColor: "#001a49",
                          borderRadius: "10%",
                          color: "white",
                        }}
                      >
                        <GiStoneBlock
                          style={{
                            fontSize: "20px",
                          }}
                        />
                      </div>
                    </div>
                    <div className="stake-left d-flex justify-content-between align-items-center">
                      <div className="d-flex py-2">
                        <div
                          className="p-2 m-2"
                          style={{
                            backgroundColor: "#001a49",
                            borderRadius: "10%",
                            color: "white",
                          }}
                        >
                          <img
                            src={require("../assets/block-flash.png")}
                            style={{
                              height: "35px",
                              backgroundSize: "cover",
                              borderRadius: "5px",
                            }}
                          />
                        </div>
                      </div>
                      <div>
                        <h6 className="fw-bolder">Total Reward</h6>
                        <h6 className="fw-bolder">
                          ${" "}
                          {Number(
                            userinfo?.levelIncome + userinfo?.directIncome
                          )?.toFixed(2)}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 mb-2">
                  <div
                    className="h-200"
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      backgroundColor: "#041025",
                      padding: "5px",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center walletImg">
                      <div className="mx-2 my-2">
                        <h6 className="fw-bolder">Self Block</h6>
                        <h6 className="fw-bolder">
                          ${Number(userinfo?.totalDeposit)?.toFixed(2)}
                        </h6>
                      </div>
                      <div
                        className="p-2 mx-2"
                        style={{
                          backgroundColor: "#001a49",
                          borderRadius: "10%",
                          color: "white",
                        }}
                      >
                        <GiStoneBlock
                          style={{
                            fontSize: "20px",
                          }}
                        />
                      </div>
                    </div>
                    <div className="stake-left d-flex justify-content-between align-items-center">
                      <div className="d-flex py-2">
                        <div
                          className="p-2 m-2"
                          style={{
                            backgroundColor: "#001a49",
                            borderRadius: "10%",
                            color: "white",
                          }}
                        >
                          <img
                            src={require("../assets/block-flash.png")}
                            style={{
                              height: "35px",
                              backgroundSize: "cover",
                              borderRadius: "5px",
                            }}
                          />
                        </div>
                      </div>
                      <div>
                        <h6 className="fw-bolder">Total Roi Earned</h6>
                        <h6 className="fw-bolder">
                          ${" "}
                          {(
                            Number(userinfo?.stake?.roi) ||
                            0 + Number(userinfo?.stake?.avlReward) ||
                            0
                          )?.toFixed(2)}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="d-flex col-xl-12 justify-content-around">
                <button className="btn btn-warning p-2 mb-3">Transfer</button>
                <button className="btn btn-info p-2 mb-3">Deposit</button>
              </div> */}
            </div>
          </div>
          <div className="row mb-3">
            <div
              class="row mt-3"
              style={{ marginRight: "0px", paddingRight: "0px" }}
            >
              <div className="col-xl-4 col-sm-12">
                <div className="row">
                  <div class="col-sm-12 col-xl-12">
                    <div className="card text-center p-4 conatiner borderAni">
                      <h3 className="text-primary">XBLOCKHUB PACKAGES</h3>
                      <h6 className=" text-secondary">Select Plan</h6>
                      {!userinfo?.isClubActive && (
                        <h6 style={{ fontSize: "17px" }} className=" mt-3">
                          Remaining Time For (3.33% ROI):{" "}
                          <span style={{ color: "#63c4ff" }}>{timer7day}</span>
                        </h6>
                      )}
                      <div className="d-lg-flex mb-2">
                        {/* Circles for each pool */}
                        <div className="d-flex flex-wrap mt-5 justify-content-center">
                          {userinfo?.packages?.map((pkg, i, arr) => {
                            return (
                              <div
                                className="d-flex flex-column align-items-center mx-2"
                                key={i + "pkgitems"}
                              >
                                <div
                                  className={`${
                                    selectedPkg === i
                                      ? "bg-success"
                                      : "bg-primary"
                                  } circle text-white d-flex justify-content-center align-items-center mb-4`}
                                  style={{
                                    width: "100px",
                                    height: "95px",
                                    flexDirection: "column",
                                    padding: "10px 5px",
                                    borderRadius: "16px",
                                    background:
                                      "linear-gradient(45deg, #2278c4, #01112a)",
                                    border: "2px solid #0675a2",
                                  }}
                                  onClick={() => setSelectedPkg(i)}
                                >
                                  <div
                                    style={{
                                      position: "relative",
                                      top: "-30%",
                                      // left: "5%",
                                    }}
                                  >
                                    <img
                                      src={require("../assets/xblock.png")}
                                      style={{
                                        height: "55px",
                                        width: "55px",
                                        backgroundSize: "contain",
                                      }}
                                    />
                                    <h5
                                      style={{
                                        color:
                                          selectedPkg === i ? "#2f6" : "#fff",
                                      }}
                                    >
                                      {(i
                                        ? (i == 4 ? 5 : i) *
                                          (i + 1 == arr.length ? 2 : 1)
                                        : "") + "XBlock"}
                                    </h5>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color:
                                          selectedPkg === i ? "#2f6" : "#fff",
                                      }}
                                    >
                                      <div>{pkg}</div>
                                      <div>$</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <span>
                        {isConnected ? (
                          <button
                            className="btn btn-primary mb-2"
                            style={{ width: "100%", borderRadius: "25px" }}
                            onClick={handleStake}
                          >
                            BLOCK{" "}
                            {userinfo?.packages
                              ? userinfo?.packages[selectedPkg]
                              : 0}
                            $
                          </button>
                        ) : (
                          <ConnectWallet />
                        )}
                        <span
                          style={{ alignSelf: "flex-end" }}
                          className="btn"
                          onClick={() => refreshStake()}
                        >
                          {userinfo?.totalEarned >= userinfo?.totalLimit &&
                            userinfo?.totalLimit > 0 && (
                              <span className=" text-danger mx-1">
                                Please Upgrade Your Plan, Limit Reached
                              </span>
                            )}
                          Refresh stake
                        </span>
                        <h5>
                          Connected Wallet:{" "}
                          <span style={{ fontSize: "12px" }}>{address}</span>
                        </h5>
                        {userinfo?.user != address?.toLowerCase() && (
                          <h6>
                            <span className=" text-danger">Note:</span>{" "}
                            <span className=" text-warning">
                              Wrong wallet Connected{" "}
                            </span>
                            connect this account (
                            <span className=" text-warning">
                              {userinfo?.user?.slice(0, 7) +
                                "..." +
                                userinfo?.user?.slice(-7)}
                            </span>
                            ) wallet
                          </h6>
                        )}
                      </span>
                    </div>
                  </div>

                  <div class="ol-sm-12 col-xl-12">
                    <div class="card shadow-none box borderAni">
                      <div class="card-body p-4">
                        <div class="d-flex align-items-center">
                          <div class=" justify-content-center">
                            <h4 class="mb-0 fw-semibold fs-4 align-items-right">
                              {" "}
                              Total Reward
                            </h4>
                          </div>

                          <div class="ms-auto text-danger d-flex align-items-center ">
                            <h3 class="fs-5 fw-bold text-danger">
                              ${(Number(userinfo?.totalEarned || 0)+Number(userinfo?.roiClaimed || 0))?.toFixed(2)}
                            </h3>
                          </div>
                        </div>
                        <div class="d-flex align-items-center mt-2">
                          <div class=" justify-content-center">
                            <h4 class="mb-0 fw-semibold fs-4 align-items-right">
                              Total Limit
                            </h4>
                          </div>

                          <div class="ms-auto text-danger d-flex align-items-center">
                            <h3 class="fs-5 fw-bold text-success">
                              ${Number(userinfo?.totalLimit || 0)?.toFixed(2)}
                            </h3>
                          </div>
                        </div>
                        <div class="d-flex align-items-center mt-2">
                          <div class=" justify-content-center">
                            <h4 class="mb-0 fw-semibold fs-3 align-items-right">
                              Roi Rate
                            </h4>
                          </div>

                          <div class="ms-auto text-danger d-flex align-items-center">
                            <h3 class="fs-3 fw-bold text-success">
                              {Number(userinfo?.roiRate || 0)}% /day
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-12 col-xl-12">
                    <div class="card shadow-none box borderAni">
                      <div class="card-body p-4">
                        <div class="d-flex align-items-center">
                          <div class="justify-content-center">
                            <h4 class="mb-0 fw-semibold fs-4 align-items-right">
                              Direct Business{" "}
                            </h4>
                          </div>

                          <div class="ms-auto text-danger d-flex align-items-center">
                            <h3 class="fs-5 fw-bold text-danger">
                              $ {userinfo?.directTeamBusiness}
                            </h3>
                          </div>
                        </div>
                        <div class="d-flex align-items-center">
                          <div class="justify-content-center">
                            <h4 class="mb-0 fw-semibold fs-4 align-items-right">
                              Team Business{" "}
                            </h4>
                          </div>

                          <div class="ms-auto text-danger d-flex align-items-center">
                            <h3 class="fs-5 fw-bold text-success">
                              $ {userinfo?.totalTeamBusiness || 0}
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-8 col-sm-12">
                <div className="row">
                  <div class="col-sm-6 col-xl-4">
                    <div class="card shadow-none box borderAni">
                      <div class="card-body p-4">
                        <div class="d-flex align-items-center">
                          <div class="round rounded bg-danger12 d-flex align-items-center justify-content-center">
                            <FaAddressCard
                              style={{ fontSize: "30px", color: "white" }}
                            />
                          </div>

                          <div class="ms-auto text-danger d-flex align-items-center">
                            <h3 class="fs-5 fw-bold">
                              {"$ "}
                              {userinfo?.airdropWallet || 0}
                            </h3>
                          </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between mt-1">
                          <h4 class="mb-0 fw-semibold fs-4 align-items-right">
                            Free Registration Bonus{" "}
                          </h4>
                          {/* <h4 className="fs-5 fw-bold">Todays Bouns</h4> */}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6 col-xl-4">
                    <div class="card  shadow-none box borderAni">
                      <div class="card-body p-4">
                        <div class="d-flex align-items-center">
                          <div class="round rounded bg-danger12 d-flex align-items-center justify-content-center">
                            <i
                              class="fa fa-dollar-sign USDT text-white fs-7"
                              title="USD"
                            ></i>
                          </div>

                          <div class="ms-auto text-danger d-flex align-items-center">
                            <h3 class="fs-5 fw-bold">
                              {" "}
                              ${" "}
                              {(userinfo?.directIncomeWallet || 0)?.toFixed(2)}
                            </h3>
                          </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between mt-2">
                          <h4 class="mb-0 fw-semibold fs-4 align-items-right">
                            {" "}
                            Direct Income Wallet
                          </h4>
                        </div>
                        <div class="d-flex align-items-center justify-content-between mt-2">
                          <h4 class="mb-0 fw-semibold fs-2 align-items-right">
                            {" "}
                            you will get
                          </h4>
                          <span>5% /week</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6 col-xl-4">
                    <div class="card  shadow-none box borderAni">
                      <div class="card-body p-4">
                        <div class="d-flex align-items-center">
                          <div class="round rounded bg-danger12 d-flex align-items-center justify-content-center">
                            <i
                              class="fa fa-dollar-sign USDT text-white fs-7"
                              title="USD"
                            ></i>
                          </div>

                          <div class="ms-auto text-danger d-flex align-items-center">
                            <h3 class="fs-5 fw-bold">
                              {" "}
                              $ {(userinfo?.levelIncome || 0)?.toFixed(2)}
                            </h3>
                          </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between mt-2">
                          <h4 class="mb-0 fw-semibold fs-4 align-items-right">
                            {" "}
                            Level Income
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6 col-xl-4">
                    <div class="card  shadow-none box borderAni">
                      <div class="card-body p-4">
                        <div class="d-flex align-items-center">
                          <div class="round rounded bg-danger12 d-flex align-items-center justify-content-center">
                            <i
                              class="fa fa-dollar-sign USDT text-white fs-7"
                              title="USD"
                            ></i>
                          </div>

                          <div class="ms-auto text-danger d-flex align-items-center">
                            <h3 class="fs-5 fw-bold">
                              $ {(userinfo?.dailySalaryIncome || 0)?.toFixed(2)}
                            </h3>
                          </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between mt-2">
                          <h4 class="mb-0 fw-semibold fs-4 align-items-right">
                            Salary Income{" "}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6 col-xl-4">
                    <div class="card  shadow-none box borderAni">
                      <div class="card-body p-4">
                        <div class="d-flex align-items-center">
                          <div class=" d-flex align-items-center justify-content-center">
                            {/* <i
                              class="fa fa-dollar-sign USDT text-white fs-7"
                              title="USD"
                            ></i> */}
                            <h6>At Level</h6>
                          </div>

                          <div class="ms-auto text-danger d-flex align-items-center">
                            <h3 class="fs-5 fw-bold">
                              {userinfo?.dailySalaryIndex + 1}
                            </h3>
                          </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between mt-2">
                          <h4 class="mb-0 fw-semibold fs-4 align-items-right">
                            {" "}
                            Need Club-Team
                          </h4>
                          <span>
                            {userinfo?.teamFordailySalary
                              ? userinfo?.teamFordailySalary[
                                  userinfo?.dailySalaryIndex
                                ]?.team
                              : 0}
                          </span>
                        </div>
                        <div class="d-flex align-items-center justify-content-between mt-2">
                          <h4 class="mb-0 fw-semibold fs-2 align-items-right">
                            {" "}
                            you will get
                          </h4>
                          <span>
                            ${" "}
                            {userinfo?.salaryincomes
                              ? userinfo?.salaryincomes[
                                  userinfo?.dailySalaryIndex
                                ]
                              : 0}
                            /day
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6 col-xl-4">
                    <div class="card  shadow-none box borderAni">
                      <div class="card-body p-4">
                        <div class="d-flex align-items-center">
                          <div class="round rounded bg-danger12 d-flex align-items-center justify-content-center">
                            {/* <i
                              class="fa fa-dollar-sign USDT text-white fs-7"
                              title="USD"
                            ></i> */}
                            <h6>Level</h6>
                          </div>

                          <div class="ms-auto text-danger d-flex align-items-center">
                            <h3
                              class="fs-5 fw-bold"
                              style={{
                                color: Number(userinfo?.dailySalaryIndex)
                                  ? "#2c2"
                                  : "#fff",
                              }}
                            >
                              {userinfo?.dailySalaryIndex
                                ? userinfo?.dailySalaryIndex + "-Star"
                                : "Not Achieved"}
                            </h3>
                          </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between mt-2">
                          <h4 class="mb-0 fw-semibold fs-4 align-items-right">
                            {" "}
                            Salary Bonus Level{" "}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6 col-xl-4">
                    <div class="card  shadow-none box borderAni">
                      <div class="card-body p-4">
                        <div class="d-flex align-items-center">
                          <div class="round rounded bg-danger12 d-flex align-items-center justify-content-center">
                            {/* <i
                              class="fa fa-dollar-sign USDT text-white fs-7"
                              title="USD"
                            ></i> */}
                            <h5>Token</h5>
                          </div>

                          <div class="ms-auto text-danger d-flex align-items-center">
                            <h3 class="fs-5 fw-bold">
                              {" "}
                              {userinfo?.blockaitotal}
                            </h3>
                          </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between mt-2">
                          <h4 class="mb-0 fw-semibold fs-4 align-items-right">
                            BLOCKAI Recieved{" "}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6 col-xl-4">
                    <div class="card  shadow-none box borderAni">
                      <div class="card-body p-4">
                        <div class="d-flex align-items-center">
                          <div class="round rounded bg-danger12 d-flex align-items-center justify-content-center">
                            <i
                              class="fa fa-dollar-sign USDT text-white fs-7"
                              title="USD"
                            ></i>
                          </div>

                          <div class="ms-auto text-danger d-flex align-items-center">
                            <h3 class="fs-5 fw-bold">
                              {" "}
                              {userinfo?.freeToken || 0}
                            </h3>
                          </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between mt-2">
                          <h4 class="mb-0 fw-semibold fs-4 align-items-right">
                            {" "}
                            BlockAI Token
                          </h4>
                          <h4
                            class="mb-0 fw-semibold fs-2 align-items-right btn"
                            onClick={handleClaim}
                          >
                            {" "}
                            Claim Token
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6 col-xl-4">
                    <div class="card  shadow-none box borderAni">
                      <div class="card-body p-4">
                        <div class="d-flex align-items-center">
                          <div class="round rounded bg-danger12 d-flex align-items-center justify-content-center">
                            <i
                              class="fa fa-dollar-sign USDT text-white fs-7"
                              title="USD"
                            ></i>
                          </div>

                          <div class="ms-auto text-danger d-flex align-items-center">
                            <h3 class="fs-5 fw-bold">
                              ${" "}
                              {(Number(userinfo?.availableReward) || 0)
                                // +
                                //   // Number(userinfo?.lapseReward || 0) +
                                //   Number(userinfo?.stake?.avlReward || 0) +
                                //   Number(userinfo?.stake?.roi || 0)
                                .toFixed(2)}
                            </h3>
                          </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between mt-2">
                          <h4 class="mb-0 fw-semibold fs-4 align-items-right">
                            {" "}
                            Available Balance{" "}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6 col-xl-4">
                    <div class="card  shadow-none box borderAni">
                      <div class="card-body p-4">
                        <div class="d-flex align-items-center">
                          <div class="round rounded bg-danger12 d-flex align-items-center justify-content-center">
                            <i
                              class="fa fa-dollar-sign USDT text-white fs-7"
                              title="USD"
                            ></i>
                          </div>

                          <div class="ms-auto text-danger d-flex align-items-center">
                            <h3 class="fs-5 fw-bold">
                              {" "}
                              $ {(userinfo?.totalWithdraw || 0)?.toFixed(2)}
                            </h3>
                          </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between mt-2">
                          <h4 class="mb-0 fw-semibold fs-4 align-items-right">
                            {" "}
                            Withdrawal
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6 col-xl-4">
                    <div class="card shadow-none box borderAni">
                      <div class="card-body p-4">
                        <div class="d-flex align-items-center">
                          <div class="justify-content-center">
                            <h4 class="mb-0 fw-semibold fs-4 align-items-right">
                              Total Team
                            </h4>
                          </div>
                          <div class="ms-auto text-danger d-flex align-items-center">
                            <h3 class="fs-5 fw-bold text-danger">
                              {userinfo?.totalTeam || 0}
                            </h3>
                          </div>
                        </div>
                        <div class="d-flex align-items-center">
                          <div class="justify-content-center">
                            <h4 class="mb-0 fw-semibold fs-4 align-items-right">
                              Direct Team
                            </h4>
                          </div>

                          <div class="ms-auto text-danger d-flex align-items-center">
                            <h3 class="fs-5 fw-bold text-success">
                              {" "}
                              <h3 class="fs-5 fw-bold text-success">
                                {userinfo?.totalDirect || 0}
                              </h3>
                            </h3>
                          </div>
                        </div>
                        <div class="d-flex align-items-center mt-2">
                          <div class="justify-content-center">
                            <h4 class="mb-0 fw-semibold fs-4 align-items-right">
                              Total Club Team
                            </h4>
                          </div>

                          <div class="ms-auto text-danger d-flex align-items-center">
                            <h3 class="fs-5 fw-bold text-success">
                              {" "}
                              <h3 class="fs-5 fw-bold text-success">
                                {userinfo?.clubInfo?.allteam || 0}
                              </h3>
                            </h3>
                          </div>
                        </div>
                        <div class="d-flex align-items-center mt-2">
                          <div class="justify-content-center">
                            <h4 class="mb-0 fw-semibold fs-4 align-items-right">
                              Direct Club Team
                            </h4>
                          </div>

                          <div class="ms-auto text-danger d-flex align-items-center">
                            <h3 class="fs-5 fw-bold text-success">
                              {" "}
                              <h3 class="fs-5 fw-bold text-success">
                                {userinfo?.clubInfo?.directClubTeam || 0}
                              </h3>
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card d-none">
              <div class="">
                <h5 class="card-title fw-semibold p-3">Recent Transactions</h5>
                <div id="transaction">
                  {" "}
                  <div class="table-responsive mt-4">
                    <table
                      class="table table-striped table-hover align-middle mb-0"
                      style={{ width: "400px" }}
                    >
                      <thead class="text-white">
                        <tr>
                          <th scope="col" class="rounded-start text-white">
                            Sr.no
                          </th>
                          <th scope="col" class="text-white">
                            Profit
                          </th>
                          <th scope="col" class="text-white">
                            Time
                          </th>
                          <th scope="col" class="rounded-end text-white">
                            Address
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="text-white">
                            <small>1</small>
                          </td>
                          <td class="text-white">
                            <small>$ 100</small>
                          </td>
                          <td class="text-white blinking-text">
                            <small>1 Sec</small>
                          </td>
                          <td
                            class="blinking-text text-truncate text-white"
                            style={{ maxWidth: "250px" }}
                          >
                            <small> 0xAdA..5bA48</small>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-white">
                            <small>2</small>
                          </td>
                          <td class="text-white">
                            <small>$ 23</small>
                          </td>
                          <td class="text-white blinking-text">
                            <small>2 Sec</small>
                          </td>
                          <td
                            class="blinking-text text-truncate text-white"
                            style={{ maxWidth: "250px" }}
                          >
                            <small> 0xf05..8f054</small>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-white">
                            <small>3</small>
                          </td>
                          <td class="text-white">
                            <small>$ 500</small>
                          </td>
                          <td class="text-white blinking-text">
                            <small>2 Sec</small>
                          </td>
                          <td
                            class="blinking-text text-truncate text-white"
                            style={{ maxWidth: "250px" }}
                          >
                            <small> 0xf05..f0a23</small>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-white">
                            <small>4</small>
                          </td>
                          <td class="text-white">
                            <small>$ 300</small>
                          </td>
                          <td class="text-white blinking-text">
                            <small>15 Sec</small>
                          </td>
                          <td
                            class="blinking-text text-truncate text-white"
                            style={{ maxWidth: "250px" }}
                          >
                            <small> 0x2Ec..d79A8</small>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-white">
                            <small>5</small>
                          </td>
                          <td class="text-white">
                            <small>$ 10</small>
                          </td>
                          <td class="text-white blinking-text">
                            <small>1 Sec</small>
                          </td>
                          <td
                            class="blinking-text text-truncate text-white"
                            style={{ maxWidth: "250px" }}
                          >
                            <small> 00xAd..A4655</small>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-white">
                            <small>6</small>
                          </td>
                          <td class="text-white">
                            <small>$ 1800</small>
                          </td>
                          <td class="text-white blinking-text">
                            <small>10 Sec</small>
                          </td>
                          <td
                            class="blinking-text text-truncate text-white"
                            style={{ maxWidth: "250px" }}
                          >
                            <small> 0xf05..8f062</small>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardHome;
